export const BRAND_NAME = 'sky11';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'baazifair.com';
export const OPERATORID = 'HypexDemo';
export const PROVIDER_ID = 'BetFair';
